module.exports = __webpack_public_path__ + "img/list_item_four.a572b073.png";